import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/global.scss'
import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.js'
import './permission'

Vue.config.productionTip = false

// Element UI 配置
Vue.use(ElementUI, {
  size: 'medium'
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

